import type { VariantProps } from "tailwind-variants";

import { Badge2 } from "@/ui2/atoms/Badge";
import type { badgeStyles } from "@/ui2/atoms/Badge";
import { cn } from "@/lib/helpers/cn";
import type { PatientAcuityScore } from "@/core/types";

type Variant = VariantProps<typeof badgeStyles>["variant"];

const ACUITY_SCORE_TO_BADGE: Record<PatientAcuityScore, { label: string; variant: Variant }> = {
  1: {
    label: "Mild",
    variant: "success",
  },
  2: {
    label: "Moderate",
    variant: "warning",
  },
  3: {
    label: "Intense",
    variant: "orange",
  },
  4: {
    label: "Severe",
    variant: "error",
  },
} as const;

type AcuityScoreBadgeProps = {
  acuityScore: PatientAcuityScore;
  className?: string;
};

export function AcuityScoreBadge({ acuityScore, className }: AcuityScoreBadgeProps) {
  const { label, variant } = ACUITY_SCORE_TO_BADGE[acuityScore] || {};

  return (
    <Badge2
      className={cn("tw:normal-case", className)}
      size="md"
      variant={variant}
    >{`${acuityScore} ${label}`}</Badge2>
  );
}
